import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useGetData } from "../../../../../hooks/useGetData";
import { useMutationData } from "../../../../../hooks/useMutationData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { FechasInterface } from "../../../../../interfaces/FechasInterface";
import { InteriorInmuebleInterface } from "../../../../../interfaces/InteriorInmuebleInterface";
import { NotasInmuebleCasaInterface } from "../../../../../interfaces/NotasInmuebleCasaInterface";
import { ZonaInmuebleCasaInterface } from "../../../../../interfaces/ZonaInmuebleCasaInterface";
import { EspacioInmuebleCasaInterface } from "../../../../../interfaces/EspacioInmuebleCasaInterface";
import { ServiciosInmuebleCasaInterface } from "../../../../../interfaces/ServiciosInmuebleCasaInterface";
import { Checkbox, Label, Textarea, TextInput } from "flowbite-react";
import { API } from "../../../../../global/global";
import HeaderPrint from "../../../../../components/HeaderFormsPrint/HeaderFormsPrint";
import fotoMapa from "../../../../../img/fotoMapa.png";

type Section =
  | "ORDEN"
  | "LIMPIEZA"
  | "MOBILIARIO"
  | "DISTRIBUCIÓN"
  | "ESPACIO"
  | "ZONAS";
type EspacioRating = "Muy Bien" | "Bien" | "Regular" | "Deficiente";

type Servicios = {
  agua: boolean;
  drenaje: boolean;
  transporte: boolean;
  vigilancia: boolean;
  telefono: boolean;
  luz: boolean;
  pavimentacion: boolean;
};

export const PropiedadListaPrint = () => {
  const tituloFormulario = "INMUEBLE CASA / DEPARTAMENTO";
  const { control, handleSubmit, setValue, reset } = useForm();
  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [images, setImages] = useState<(File | null)[]>([null]);
  const [selectedZones, setSelectedZones] = useState<string[]>([]);
  const [serviceSelection, setServiceSelection] = useState<string[]>([]);
  const [notes, setNotes] = useState<string>("");
  const [notesPage2, setNotesPage2] = useState<string>("");
  const [photoUrl, setPhotoUrl] = useState<string | null>(null);
  const [fechaNacimiento, setFechaNacimiento] = useState<string>("");
  const [edad, setEdad] = useState<number | null>(null);
  const [formData, setFormData] = useState({});
  const [isReady, setIsReady] = useState(false);
  const [isEspacioReady, setIsEspacioReady] = useState(false);
  const [isZonasReady, setIsZonasReady] = useState(false);
  const [isServiciosReady, setIsServiciosReady] = useState(false);

  const [ordenSeleccionado, setOrdenSeleccionado] = useState<string | null>(
    null
  );
  const [limpiezaSeleccionada, setLimpiezaSeleccionada] = useState<
    string | null
  >(null);
  const [mobiliarioSeleccionado, setMobiliarioSeleccionado] = useState<
    string | null
  >(null);
  const [distribucionSeleccionado, setDistribucionSeleccionado] = useState<
    string | null
  >(null);

  const [zonasSeleccionadas, setZonasSeleccionadas] = useState<{
    [key: string]: boolean;
  }>({
    sala: false,
    cocina: false,
    recamaras: false,
    cochera: false,
    lavado: false,
    baniosCompletos: false,
    mediosBanios: false,
    jaula: false,
    balcones: false,
    patios: false,
  });

  const [serviciosSeleccionados, setServiciosSeleccionados] =
    useState<Servicios>({
      agua: false,
      drenaje: false,
      transporte: false,
      vigilancia: false,
      telefono: false,
      luz: false,
      pavimentacion: false,
    });

  const [espacioSeleccionado, setEspacioSeleccionado] = useState<string | null>(
    null
  );

  const [selectedEspacioRating, setSelectedEspacioRating] = useState<
    EspacioRating | ""
  >("");

  const rows = ["ORDEN", "LIMPIEZA", "MOBILIARIO", "DISTRIBUCIÓN"];
  const columns = ["MUY BIEN", "BIEN", "REGULAR", "DEFICIENTE"];

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    const updatedFormData = { ...formData, [name]: value };
    setFormData(updatedFormData);
  };

  const calcularEdad = (fechaNacimiento: string) => {
    const fechaNac = new Date(fechaNacimiento);
    const hoy = new Date();
    let edadCalculada = hoy.getFullYear() - fechaNac.getFullYear();
    const mes = hoy.getMonth() - fechaNac.getMonth();

    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
      edadCalculada--;
    }

    return edadCalculada;
  };

  const handleFechaNacimientoChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const nuevaFechaNacimiento = event.target.value;
    setFechaNacimiento(nuevaFechaNacimiento);

    const nuevaEdad = calcularEdad(nuevaFechaNacimiento);
    setEdad(nuevaEdad);
  };

  const handlePageChange = (newPage: number) => {
    const filledImages = images.filter((image) => image);
    setImages(filledImages.length > 0 ? filledImages : [null]);
    setCurrentPage(newPage);
  };

  const handleZoneChange = (zone: string) => {
    setSelectedZones((prev) => {
      const newZones = prev.includes(zone)
        ? prev.filter((z) => z !== zone)
        : [...prev, zone];
      return newZones;
    });
  };

  const handleNotesChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newNotes = event.target.value;
    setNotes(newNotes);
  };

  const handleNotesPage2Change = (
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    const newNotes = event.target.value;
    setNotesPage2(newNotes);
  };

  const resetFormData = () => {
    const emptyFormData = {
      visitDate: "",
      name: "",
      rfc: "",
      sex: "",
      civilStatus: "",
      education: "",
      birthDate: "",
      curp: "",
      company: "",
      cp: "",
    };
    setFormData(emptyFormData);
    setSelectedEspacioRating("");
  };

  const handleImageChange = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (file) {
      const newImages = [...images];
      newImages[index] = file;
      setImages(newImages);
    }
  };

  const handleEspacioChange = (espacio: string) => {
    setEspacioSeleccionado(espacio);
  };

  const handleOrdenChange = (orden: string) => {
    setOrdenSeleccionado(orden);
  };

  const handleMobiliarioChange = (option: string) => {
    setMobiliarioSeleccionado(option);
  };

  const handleDistribucionChange = (option: string) => {
    setDistribucionSeleccionado(option);
  };

  const handleLimpiezaChange = (limpieza: string) => {
    setLimpiezaSeleccionada(limpieza);
  };

  const handleZonaChange = (zona: string) => {
    setZonasSeleccionadas((prev) => ({
      ...prev,
      [zona]: !prev[zona],
    }));
  };

  const handleServicioChange = (servicio: keyof Servicios, valor: boolean) => {
    setServiciosSeleccionados((prev) => ({ ...prev, [servicio]: valor }));
  };

  const addImageBox = () => {
    setImages([...images, null]);
  };

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const queryFecha = useGetData<FechasInterface[]>({
    url: `/evaluado/${evaluadosList_id}/fecha-visita-bienesinmuebles`,
    name: ["fecha-visita-bienesinmuebles"],
  });

  const mutateFecha = useMutationData({
    url: `/evaluado/${evaluadosList_id}/fecha-visita-bienesinmuebles`,
    reload: ["evaluado", `${evaluadosList_id}`, "fecha-visita-bienesinmuebles"],
  });

  const queryInteriorInmueble = useGetData<InteriorInmuebleInterface[]>({
    url: `/interior-inmueble/${evaluadosList_id}`,
    name: ["interior-inmueble"],
  });

  const mutateInteriorInmueble = useMutationData({
    url: `/interior-inmueble/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "interior-inmueble"],
  });

  const queryZonaInmueble = useGetData<ZonaInmuebleCasaInterface[]>({
    url: `/zonas_inmueblecasa/${evaluadosList_id}`,
    name: ["zonas_inmueblecasa"],
  });

  const mutateZonaInmueble = useMutationData({
    url: `/zonas_inmueblecasa/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "zonas_inmueblecasa"],
  });

  const queryEspacioInmueble = useGetData<EspacioInmuebleCasaInterface[]>({
    url: `/espacio-inmueblecasa/${evaluadosList_id}`,
    name: ["espacio-inmueblecasa"],
  });

  const mutateEspacioInmueble = useMutationData({
    url: `/espacio-inmueblecasa/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "espacio-inmueblecasa"],
  });

  const queryServiciosInmueble = useGetData<ServiciosInmuebleCasaInterface[]>({
    url: `/servicios-inmueblecasa/${evaluadosList_id}`,
    name: ["servicios-inmueblecasa"],
  });

  const mutateServiciosInmueble = useMutationData({
    url: `/servicios-inmueblecasa/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "servicios-inmueblecasa"],
  });

  const queryNotasInmueble = useGetData<NotasInmuebleCasaInterface[]>({
    url: `/notas-inmueblecasa/${evaluadosList_id}`,
    name: ["notas-inmueblecasa"],
  });

  const mutateNotasInmuebles = useMutationData({
    url: `/notas-inmueblecasa/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "notas-inmueblecasa"],
  });

  const generoMap: { [key: string]: string } = {
    M: "Masculino",
    F: "Femenino",
    O: "Otro",
  };

  const generoTexto =
    generoMap[queryEvaluado.data?.genero as string] || "No especificado";

  const domicilio = `${queryEvaluado.data?.calle || ""}, ${
    queryEvaluado.data?.numero_exterior || ""
  }, ${queryEvaluado.data?.colonia || ""}, ${
    queryEvaluado.data?.codigo_postal || ""
  }, ${queryEvaluado.data?.municipio || ""}, ${
    queryEvaluado.data?.estado || ""
  }, ${queryEvaluado.data?.pais || ""}`;

  useEffect(() => {
    if (queryEvaluado.data) {
      const fechaNac = queryEvaluado.data.fecha_nacimiento || "";
      setFechaNacimiento(fechaNac);

      const nuevaEdad = calcularEdad(fechaNac);
      setEdad(nuevaEdad);

      reset({
        nombre: queryEvaluado.data.nombre || "",
        apellido_paterno: queryEvaluado.data.apellido_paterno || "",
        apellido_materno: queryEvaluado.data.apellido_materno || "",
        rfc: queryEvaluado.data.rfc || "",
        genero: queryEvaluado.data.genero || "",
        estado_civil: queryEvaluado.data.estado_civil || "",
        escolaridad: queryEvaluado.data.escolaridad || "",
        fecha_nacimiento: fechaNac,
        curp: queryEvaluado.data.curp || "",
        empresa: queryEvaluado.data.empresa?.nombre || "",
        codigo_postal: queryEvaluado.data.codigo_postal || "",
      });
    }
  }, [queryEvaluado.data, reset]);

  useEffect(() => {
    if (queryFecha.data && queryFecha.data.length > 0) {
      const registroValido = queryFecha.data.find(
        (item) => item.fecha_inmueblecasa
      );

      if (registroValido) {
        setValue("fecha_inmueblecasa", registroValido.fecha_inmueblecasa);
      }
    }
  }, [queryFecha.data, setValue]);

  useEffect(() => {
    if (queryInteriorInmueble.data && queryInteriorInmueble.data.length > 0) {
      const { orden, limpieza, mobiliario, distribucion } =
        queryInteriorInmueble.data[0];
      setOrdenSeleccionado(orden || null);
      setLimpiezaSeleccionada(limpieza || null);
      setMobiliarioSeleccionado(mobiliario || null);
      setDistribucionSeleccionado(distribucion || null);
      setIsReady(true);
    }
  }, [queryInteriorInmueble.data]);

  useEffect(() => {
    if (
      queryZonaInmueble.data &&
      Array.isArray(queryZonaInmueble.data) &&
      queryZonaInmueble.data.length > 0
    ) {
      const {
        sala_comedor,
        cocina,
        recamaras,
        cochera,
        area_lavado,
        banios_completos,
        medios_banios,
        jaula_tendido,
        balcones,
        patios,
      } = queryZonaInmueble.data[0];

      setZonasSeleccionadas({
        sala: sala_comedor ?? false,
        cocina: cocina ?? false,
        recamaras: recamaras ?? false,
        cochera: cochera ?? false,
        lavado: area_lavado ?? false,
        baniosCompletos: banios_completos ?? false,
        mediosBanios: medios_banios ?? false,
        jaula: jaula_tendido ?? false,
        balcones: balcones ?? false,
        patios: patios ?? false,
      });

      setIsZonasReady(true);
    }
  }, [queryZonaInmueble.data]);

  useEffect(() => {
    if (queryEspacioInmueble.data && queryEspacioInmueble.data.length > 0) {
      const { espacio_del_inmueblecasa } = queryEspacioInmueble.data[0];

      if (
        ["Sobrado", "Suficiente", "Insuficiente"].includes(
          espacio_del_inmueblecasa
        )
      ) {
        setEspacioSeleccionado(espacio_del_inmueblecasa);
      } else {
        setEspacioSeleccionado(null);
      }
      setIsEspacioReady(true);
    }
  }, [queryEspacioInmueble.data]);

  useEffect(() => {
    if (
      queryServiciosInmueble.data &&
      Array.isArray(queryServiciosInmueble.data) &&
      queryServiciosInmueble.data.length > 0
    ) {
      const {
        agua,
        drenaje,
        transporte,
        vigilancia,
        telefono,
        luz,
        pavimentacion,
      } = queryServiciosInmueble.data[0];

      setServiciosSeleccionados({
        agua: agua ?? false,
        drenaje: drenaje ?? false,
        transporte: transporte ?? false,
        vigilancia: vigilancia ?? false,
        telefono: telefono ?? false,
        luz: luz ?? false,
        pavimentacion: pavimentacion ?? false,
      });

      setIsServiciosReady(true);
    }
  }, [queryServiciosInmueble.data]);

  useEffect(() => {
    if (queryNotasInmueble.data && queryNotasInmueble.data.length > 0) {
      const nota = queryNotasInmueble.data[0];
      reset({
        nota_inmueblecasa: nota.nota_inmueblecasa || "",
      });
    }
  }, [queryNotasInmueble.data, reset]);

  useEffect(() => {
    if (evaluadosList_id) {
      const token = localStorage.getItem("token");
      fetch(`${API}/evaluado/${evaluadosList_id}/ubicacion`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.photos) {
            setPhotoUrl(data.photos[5] || null);
          } else {
            setPhotoUrl(null);
          }
        })
        .catch((error) => {
          console.error("Error al obtener la URL de la foto:", error);
          setPhotoUrl(null);
        });
    }
  }, [evaluadosList_id]);

  const imageUrl = `http://localhost:8000/storage/evaluados/photos/${evaluadosList_id}/Croquis.png`;

  return (
    <div className="max-w-[800px] mx-auto p-4 bg-white">
      {/* Marca de agua */}
      <div className="absolute inset-0 flex justify-center items-center pointer-events-none z-0">
        <div
          className="text-blue-500 text-9xl font-bold transform rotate-[-48deg]"
          style={{ opacity: 0.1 }}
        >
          CONFIDENCIAL
        </div>
      </div>
      {/* Header */}
      <HeaderPrint titulo={tituloFormulario} />
      {/* Título del formulario */}
      <div id="headerContent" className="text-center">
        <h1
          className="text-black text-xl font-bold py-3 px-8 rounded-b-md inline-block shadow-lg flex justify-center transition-transform duration-300 ease-in-out hover:scale-105 cursor-pointer"
          style={{
            backgroundImage: `url(${fotoMapa})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {tituloFormulario}
        </h1>
      </div>
      <div className="space-y-1 p-1 mt-2">
        <div className="grid grid-cols-3 gap-2">
          <div className="col-span-1 flex items-center">
            <Label htmlFor="fecha_bienesinmuebles" className="mr-2">
              FECHA VISITA:
            </Label>
            <Controller
              name="fecha_inmueblecasa"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextInput
                  id="fecha_inmueblecasa"
                  type="date"
                  {...field}
                  value={
                    field.value ||
                    (queryFecha.data && queryFecha.data.length > 0
                      ? queryFecha.data[0]?.fecha_inmueblecasa || ""
                      : "")
                  }
                  disabled={true}
                  onChange={(e) => {
                    field.onChange(e.target.value);
                  }}
                  className="text-center w-full"
                />
              )}
            />
          </div>
          <div className="col-span-2">
            <Label htmlFor="nombre">NOMBRE:</Label>
            <TextInput
              id="nombre"
              name="nombre"
              value={`${queryEvaluado.data?.nombre || ""} ${
                queryEvaluado.data?.apellido_paterno || ""
              } ${queryEvaluado.data?.apellido_materno || ""}`}
              onChange={handleInputChange}
              disabled={true}
            />
          </div>
          {/* Campo para RFC */}
          <div className="col-span-1">
            <Label htmlFor="rfc">RFC:</Label>
            <TextInput
              id="rfc"
              name="rfc"
              onChange={handleInputChange}
              value={queryEvaluado.data?.rfc || ""}
              disabled={true}
            />
          </div>
          {/* Edad */}
          <div className="col-span-1">
            <Label htmlFor="edad">EDAD:</Label>
            <TextInput
              id="edad"
              name="edad"
              value={edad !== null ? edad.toString() : ""}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="sexo">SEXO:</Label>
            <TextInput
              id="sexo"
              name="sexo"
              value={generoTexto}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="estadoCivil">ESTADO CIVIL:</Label>
            <TextInput
              id="estadoCivil"
              name="estadoCivil"
              onChange={handleInputChange}
              value={`${queryEvaluado.data?.estado_civil || ""}`}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="escolaridad">ESCOLARIDAD:</Label>
            <TextInput
              id="escolaridad"
              name="escolaridad"
              onChange={handleInputChange}
              value={`${queryEvaluado.data?.escolaridad || ""}`}
              disabled={true}
            />
          </div>
          <div className="col-span-1 flex items-center">
            <Label htmlFor="fechaNacimiento" className="mr-2">
              FECHA DE NACIMIENTO:
            </Label>
            <TextInput
              id="fechaNacimiento"
              name="fechaNacimiento"
              value={`${queryEvaluado.data?.fecha_nacimiento || ""}`}
              disabled={true}
              type="date"
              onChange={handleInputChange}
              className="w-32"
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="curp">CURP:</Label>
            <TextInput
              id="curp"
              name="curp"
              onChange={handleInputChange}
              value={queryEvaluado.data?.curp || ""}
              disabled={true}
            />
          </div>
          <div className="col-span-1">
            <Label htmlFor="empresa">EMPRESA:</Label>
            <TextInput
              id="empresa_id"
              name="empresa"
              value={queryEvaluado.data?.empresa_id?.nombre || ""}
              onChange={handleInputChange}
              disabled={true}
            />
          </div>
        </div>
      </div>
      <div className="mt-[50px]"></div>
      {/* Tabla del Interior del Inmueble */}
      <div className="border border-gray-300">
        <div className="bg-blue-100 p-2 text-center font-semibold text-gray-700 border-b border-gray-300">
          INTERIOR DEL INMUEBLE
        </div>
        <div className="overflow-x-auto">
          <table className="table-auto border-collapse border border-gray-300 w-full text-center">
            <thead className="bg-customBlue text-white">
              <tr>
                <th className="border border-gray-300 p-2">Categoría</th>
                <th className="border border-gray-300 p-2">Muy Bien</th>
                <th className="border border-gray-300 p-2">Bien</th>
                <th className="border border-gray-300 p-2">Regular</th>
                <th className="border border-gray-300 p-2">Deficiente</th>
              </tr>
            </thead>
            <tbody>
              {["ORDEN", "LIMPIEZA", "MOBILIARIO", "DISTRIBUCIÓN"].map(
                (category) => (
                  <tr key={category} className="border border-gray-300">
                    <td className="border border-gray-300 p-2 font-bold text-gray-700">
                      {category}
                    </td>
                    {["Muy Bien", "Bien", "Regular", "Deficiente"].map(
                      (rating) => (
                        <td key={rating} className="border border-gray-300 p-2">
                          {isReady && (
                            <Checkbox
                              id={`${category.toLowerCase()}-${rating}`}
                              checked={
                                category === "ORDEN"
                                  ? ordenSeleccionado === rating
                                  : category === "LIMPIEZA"
                                  ? limpiezaSeleccionada === rating
                                  : category === "MOBILIARIO"
                                  ? mobiliarioSeleccionado === rating
                                  : distribucionSeleccionado === rating
                              }
                              onChange={() =>
                                category === "ORDEN"
                                  ? setOrdenSeleccionado(rating)
                                  : category === "LIMPIEZA"
                                  ? setLimpiezaSeleccionada(rating)
                                  : category === "MOBILIARIO"
                                  ? handleMobiliarioChange(rating)
                                  : handleDistribucionChange(rating)
                              }
                              disabled={true}
                            />
                          )}
                        </td>
                      )
                    )}
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div className="mt-[250px]"></div>
      {/* Sección de Notas */}
      <div className="border border-gray-300">
        <div className="bg-blue-100 p-2 text-center font-semibold text-gray-700 border-b border-gray-300">
          NOTAS
        </div>
        <Controller
          name="nota_inmueblecasa"
          control={control}
          defaultValue={
            queryNotasInmueble.data && queryNotasInmueble.data.length > 0
              ? queryNotasInmueble.data[0]?.nota_inmueblecasa || ""
              : ""
          }
          render={({ field: { value, onChange, ...field } }) => (
            <Textarea
              id="nota_inmueblecasa"
              {...field}
              value={value}
              rows={4}
              onChange={(e) => {
                onChange(e);
                handleNotesPage2Change(e);
              }}
              disabled={true}
              onInput={(e) => {
                const target = e.target as HTMLTextAreaElement;
                target.style.height = "auto";
                target.style.height = `${target.scrollHeight}px`;
              }}
              className="mt-2 p-2 border rounded-md border-gray-300 resize-none"
              style={{ height: "auto", overflow: "hidden" }}
            />
          )}
        />
      </div>
      <div className="mt-[600px]"></div>
      <div className="p-4 border-t border-gray-300">
        <div className="text-center">
          <p className="text-left text-xs text-gray-600">
            Bajo protesta de decir verdad, hago constar que los datos
            proporcionados son verdaderos. Asimismo, autorizo a la empresa SKA
            TRACKING AND SECURITY S.A. de C.V. para que proporcione toda la
            información, documentos y todos los datos que derive de las
            evaluaciones de pruebas de confianza que se me realicen.
          </p>
          <p className="text-right text-xs text-gray-600">
            ___________________________
            <br />
            Nombre y Firma del Evaluado
          </p>
        </div>
      </div>
      <div className="mt-[650px]"></div>
      {/* Header */}
      <HeaderPrint titulo={tituloFormulario} />
      {/* Título del formulario */}
      <div id="headerContent" className="text-center">
        <h1
          className="text-black text-xl font-bold py-3 px-8 rounded-b-md inline-block shadow-lg flex justify-center transition-transform duration-300 ease-in-out hover:scale-105 cursor-pointer"
          style={{
            backgroundImage: `url(${fotoMapa})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          {tituloFormulario}
        </h1>
      </div>
      {/* Marca de agua */}
      <div className="absolute inset-0 top-[150%] flex justify-center items-center pointer-events-none z-0">
        <div
          className="text-blue-500 text-9xl font-bold transform rotate-[-48deg]"
          style={{ opacity: 0.1 }}
        >
          CONFIDENCIAL
        </div>
      </div>
      {/* Tabla de Zonas del inmueble */}
      <div className="border border-gray-300 mt-2">
        <div className="bg-blue-100 p-2 text-center font-semibold text-gray-700 border-b border-gray-300">
          ZONAS DEL INMUEBLE
        </div>
        <table className="w-full border-collapse">
          <tbody>
            {[
              [
                { id: "sala_comedor", label: "Sala-comedor", key: "sala" },
                { id: "cocina", label: "Cocina", key: "cocina" },
                { id: "recamaras", label: "Recámaras", key: "recamaras" },
                { id: "cochera", label: "Cochera", key: "cochera" },
                { id: "area_lavado", label: "Área de lavado", key: "lavado" },
              ],
              [
                {
                  id: "banios_completos",
                  label: "Baños completos",
                  key: "baniosCompletos",
                },
                {
                  id: "medios_banios",
                  label: "Medios baños",
                  key: "mediosBanios",
                },
                {
                  id: "jaula_tendido",
                  label: "Jaula de tendido",
                  key: "jaula",
                },
                { id: "balcones", label: "Balcones", key: "balcones" },
                { id: "patios", label: "Patios", key: "patios" },
              ],
            ].map((row, rowIndex) => (
              <tr key={rowIndex}>
                {row.map(({ id, label, key }) => (
                  <td key={id} className="border border-gray-300 px-4 py-2">
                    <label className="flex items-center space-x-2">
                      {isZonasReady && (
                        <Checkbox
                          id={id}
                          checked={zonasSeleccionadas[key]}
                          onChange={() => handleZonaChange(key)}
                          disabled={true}
                        />
                      )}
                      <span>{label}</span>
                    </label>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Tabla de Espacio */}
      <div className="border border-gray-300 mt-2">
        <div className="bg-blue-100 p-2 text-center font-semibold text-gray-700 border-b border-gray-300">
          ESPACIO
        </div>
        <table className="w-full border-collapse text-center">
          <thead>
            <tr>
              <th className="border border-gray-300 px-4 py-2">SOBRADO</th>
              <th className="border border-gray-300 px-4 py-2">SUFICIENTE</th>
              <th className="border border-gray-300 px-4 py-2">INSUFICIENTE</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              {["Sobrado", "Suficiente", "Insuficiente"].map((spaces) => (
                <td key={spaces} className="border border-gray-300 px-4 py-2">
                  {isEspacioReady && (
                    <Checkbox
                      id={`espacio-${spaces.toLowerCase()}`}
                      checked={espacioSeleccionado === spaces}
                      onChange={() => handleEspacioChange(spaces)}
                      disabled={true}
                    />
                  )}
                </td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
      {/* Tabla de servicios */}
      <div className="border border-gray-300 mt-2">
        <div className="bg-blue-100 p-2 text-center font-semibold text-gray-700 border-b border-gray-300">
          SERVICIOS
        </div>
        <table className="w-full border-collapse table-fixed">
          {" "}
          <thead>
            <tr>
              <th className="border border-gray-300 px-4 py-2">AGUA</th>
              <th className="border border-gray-300 px-4 py-2">DRENAJE</th>
              <th className="border border-gray-300 px-4 py-2">TRANSPORTE</th>
              <th className="border border-gray-300 px-4 py-2">VIGILANCIA</th>
              <th className="border border-gray-300 px-4 py-2">TELÉFONO</th>
            </tr>
          </thead>
          <tbody>
            {[
              [
                { id: "agua", label: "Agua", key: "agua" },
                { id: "drenaje", label: "Drenaje", key: "drenaje" },
                { id: "transporte", label: "Transporte", key: "transporte" },
                { id: "vigilancia", label: "Vigilancia", key: "vigilancia" },
                { id: "telefono", label: "Teléfono", key: "telefono" },
              ],
              [
                { id: "luz", label: "Luz", key: "luz" },
                {
                  id: "pavimentacion",
                  label: "Pavimentación",
                  key: "pavimentacion",
                },
              ],
            ].map((row, rowIndex) => (
              <tr key={rowIndex}>
                {row.map(({ id, label, key }, cellIndex) => (
                  <td
                    key={id}
                    className="border border-gray-300 px-4 py-2"
                    colSpan={rowIndex === 1 && cellIndex === 0 ? 2 : 1}
                    style={{ minWidth: "150px" }}
                  >
                    <label className="flex items-center space-x-2">
                      {isServiciosReady && (
                        <Checkbox
                          id={id}
                          checked={
                            serviciosSeleccionados[key as keyof Servicios]
                          }
                          onChange={(e) => {
                            const newValue = e.target.checked;
                            setServiciosSeleccionados((prev) => ({
                              ...prev,
                              [key]: newValue,
                            }));
                            handleServicioChange(
                              key as keyof Servicios,
                              newValue
                            );
                          }}
                          disabled={true}
                        />
                      )}
                      <span>{label}</span>
                    </label>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="mt-[375px]"></div>
      <div className="space-y-4 p-4">
        <h2 className="text-lg font-semibold mb-4">Ubicación en el Mapa</h2>
        <TextInput
          id="domicilio"
          name="domicilio"
          onChange={handleInputChange}
          value={domicilio}
          disabled={true}
        />
        {/* Mostrar la imagen si existe */}
        <div className="mt-4">
          <h3 className="text-md font-medium">Imagen del Croquis:</h3>
          <div className="flex justify-center mt-2">
            <img
              src={imageUrl}
              alt="Croquis"
              className="w-full max-w-md h-auto border-2 border-gray-300 rounded-lg"
            />
          </div>
        </div>
      </div>
      <div className="mt-[250px]"></div>
      <div className="p-4 border-t border-gray-300">
        <div className="text-center">
          <p className="text-left text-xs text-gray-600">
            Bajo protesta de decir verdad, hago constar que los datos
            proporcionados son verdaderos. Asimismo, autorizo a la empresa SKA
            TRACKING AND SECURITY S.A. de C.V. para que proporcione toda la
            información, documentos y todos los datos que derive de las
            evaluaciones de pruebas de confianza que se me realicen.
          </p>
        </div>
        <div className="flex justify-end">
          <p className="text-right text-xs text-gray-600">
            ___________________________
            <br />
            Nombre y Firma del Evaluado
          </p>
        </div>
      </div>
    </div>
  );
};
